var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.3088C25 12.385 24.9993 12.461 24.9979 12.5368H25C25 25.5294 12.4999 31 12.4999 31C12.4999 31 0 25.5294 0 12.5368H0.00210179C0.000702609 12.461 0 12.385 0 12.3088C0 5.51083 5.59644 0 12.5 0C19.4036 0 25 5.51083 25 12.3088ZM12.5 20.9706C17.3581 20.9706 21.2963 17.0926 21.2963 12.3089C21.2963 7.52512 17.3581 3.64713 12.5 3.64713C7.64194 3.64713 3.7037 7.52512 3.7037 12.3089C3.7037 17.0926 7.64194 20.9706 12.5 20.9706Z",
    fill: "#D7D7D7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin.c964a04330c6725504a5c904cc2b4f48.svg";